import MobileDeviceTable from './MobileDeviceTable'

export default MobileDeviceTable
